const payouts = {
    state: {
        fromPayout: null,
        toPayout: null
    },
    getters: {
        getFromPayout(state) {
            return state.fromPayout;
        },
        getToPayout(state) {
            return state.toPayout;
        }
    },
    mutations: {
        setFromPayout(state, fromPayout) {
            state.fromPayout = fromPayout;
        },
        setToPayout(state, toPayout) {
            state.toPayout = toPayout;
        }
    },
    actions: {
        setCurrentFromPayout({ commit }, fromPayout) {
            commit('setFromPayout', fromPayout);
        },
        setCurrentToPayout({ commit }, toPayout) {
            commit('setToPayout', toPayout);
        }
    }
};

export default payouts;
